import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import configureStore from './redux/configure';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { preloadImages } from './assets/static-images';
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.scss';
import App from './App';
import * as serviceWorker from './serviceWorker';
import * as Sentry from "@sentry/react";
import { BrowserTracing } from "@sentry/tracing";

preloadImages();

const {
	history,
	store,
	persistor 
} = configureStore({});

Sentry.init({
  dsn: "https://4ad8e175e82f448dbe814c14fbb53be0@o1281049.ingest.sentry.io/6528552",
	environment: window.globalConfig.sentryEnv,
  integrations: [new BrowserTracing()],

  // We recommend adjusting this value in production, or using tracesSampler
  // for finer control
  tracesSampleRate: 1.0,
});

ReactDOM.render(
	<Provider store={store}>
		<PersistGate loading="Loading..." persistor={persistor}>
			<App history={history} />
		</PersistGate>
	</Provider>,
	document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
